import { Vector3 } from "three";
import { MidpointStakeLayout } from "@/data/content";

/**
 * Calculates the coordinates of a midpoint stake based on the origin point, reference point, and additional rotation from the reference point (if any).
 *
 * @param {string} midPointName - The name of the midpoint stake.
 * @param {Vector3} originPosition - The position of the origin point.
 * @param {Vector3} referencePosition - The position of the reference point.
 * @param {number | null} rotationFromReference - The additional rotation from the reference point (in radians).
 * @returns {Vector3} The calculated position of the midpoint stake.
 */
export const getCalculatedMidpointCoordinates = (
  midPointName,
  originPosition,
  referencePosition,
  rotationFromReference = null
) => {
  const distance = MidpointStakeLayout[midPointName].DISTANCE;
  const deflection = MidpointStakeLayout[midPointName].DEFLECTION;

  // Calculate the initial position along origin to reference line
  // This will be the correct distance from origin, but with a deflection angle of 0
  const distancePosition = new Vector3(originPosition.x, 0, originPosition.z);
  const direction = new Vector3()
    .subVectors(referencePosition, originPosition)
    .normalize();
  distancePosition.add(direction.multiplyScalar(distance));

  // Apply deflection rotation around origin point, adding additional rotation if provided
  const rotationMatrix = new Vector3()
    .subVectors(distancePosition, originPosition) // Get vector from origin to new position
    .applyAxisAngle(new Vector3(0, 1, 0), -deflection) // Rotate around Y-axis as though the vector is at the origin
    .applyAxisAngle(new Vector3(0, 1, 0), rotationFromReference) // Rotate around Y-axis as though the vector is at the origin
    .add(originPosition); // Translate back to origin-relative position;
  return rotationMatrix;
};
